<template>
  <div v-show="cargoInfo.name" class="dialog-more flex-al-stretch flex-align-center flex-jc-bt">
    <div class="flex-45">
      <div class="flex-jc-bt item">
        <div v-title class="flex-50 pop-title">{{ $l('SourceEnd') }}</div>
        <div class="flex-45 pop-content">{{ cargoInfo.creatorId ? 'UserClient' : 'Shiplus' }}</div>
        <!--        <div class="flex-45 pop-content">{{ cargoInfo.creatorCorpName }}</div> -->
      </div>
      <div class="flex-jc-bt item">
        <div v-title class="flex-50 pop-title">{{ $l('CargoDescriptionSerialNo') }}</div>
        <div class="flex-45 pop-content">{{ cargoInfo.serialNo }}</div>
      </div>
      <div v-show="cargoPics?.length>0" class="flex-jc-bt item">
        <div v-title class="flex-50 pop-title">{{ $l('CargoPhotos') }}</div>
        <div class="flex-45 pop-content">
          <!--          <img :src="Object.values(cargoInfo.cargoPics.files||{})?.[0]" width="68" height="38" -->
          <!--               class="mg-r-20 of-contain pointer" -->
          <!--               @click="showPicFull(Object.values(cargoInfo.cargoPics.files||{})?.[0])"> -->
          <ImgListPreview :list="cargoPics" />
        </div>
      </div>

      <SpDivider class="mg-b-40 mg-t-40" direction="horizen" :width="0.8" :opacity="0.4" />

      <div v-triangle class="fw-bold pd-l-40">{{ $l('CargoNameCategory') }}</div>
      <div class="flex-jc-bt item-close">
        <div v-title class="flex-50 pop-title">{{ $l('CargoNameforTrade') }}</div>
        <div class="flex-45 pop-content">{{ cargoInfo.name }}</div>
      </div>
      <div class="flex-jc-bt item-close">
        <div v-title class="flex-50 pop-title">{{ $l('IMSBCCODE') }}</div>
        <div class="flex-45 pop-content">{{ cargoInfo.imsbcCode }}</div>
      </div>

      <SpDivider class="mg-b-30 mg-t-30" direction="horizen" :width="0.8" :opacity="0.4" />

      <div v-triangle class="fw-bold pd-l-40">{{ $l('PackingDimension') }}</div>
      <div class="flex-jc-bt item-close">
        <div v-title class="flex-50 pop-title">{{ $l('PackingMethod') }}</div>
        <div class="flex-45 pop-content">{{ cargoInfo.packingMethod }}</div>
      </div>
      <div class="flex-jc-bt item-close">
        <div v-title class="flex-50 pop-title">{{ $l('PackingDimensionDesccription') }}</div>
        <div class="flex-45 pop-content">{{ cargoInfo.packingDimensionDesc }}</div>
      </div>

      <SpDivider class="mg-b-30 mg-t-30" direction="horizen" :width="0.8" :opacity="0.4" />

      <div v-triangle class="fw-bold pd-l-40">{{ $l('BillingUnitandStowageParameters') }}</div>

      <div class="flex-jc-bt item-close">
        <div v-title class="flex-50 pop-title">{{ $l('OceanfreightBillingUnits') }}</div>
        <div class="flex-45 pop-content">{{ cargoInfo.obUnit }}</div>
      </div>
      <div class="flex-jc-bt item-close">
        <div v-title class="flex-50 pop-title">{{ $l('StowageFactor') }}</div>
        <div class="flex-45 pop-content">
          <div v-if="cargoInfo.extInput?.sf?.dwt" style="line-height: 100px">
            DWT
          </div>
          <div v-else-if="cargoInfo.extInput?.sf?.aboutCbm" class="">
            {{ cargoInfo.sfMin }} - {{ cargoInfo.sfMax }}
            <p>
              {{ cargoInfo.extInput?.sf?.aboutCbm }}
            </p>
          </div>
          <div v-else-if="cargoInfo.extInput?.sf?.aboutCbft" class="">
            {{ cargoInfo.extInput?.sf?.cbftMin }} - {{ cargoInfo.extInput?.sf?.cbftMax }}
            <p>
              {{ cargoInfo.extInput?.sf?.aboutCbft }}
            </p>
          </div>
          <div v-else>{{ cargoInfo.sfMin }} - {{ cargoInfo.sfMax }}</div>
        </div>
      </div>
      <div class="flex-jc-bt item-close">
        <div v-title class="flex-50 pop-title">{{ $l('WeightFactor') }}</div>
        <div class="flex-45 pop-content">{{ `${cargoInfo.wfMin} - ${cargoInfo.wfMax}` }}</div>
      </div>
      <div class="flex-jc-bt item-close">
        <div v-title class="flex-50 pop-title">{{ $l('TradeBillingUnits') }}</div>
        <div class="flex-45 pop-content">{{ cargoInfo.tbUnit }}</div>
      </div>
    </div>

    <SpDivider :height="1" :opacity="0.4" />

    <div class="flex-50">
      <div v-triangle class="fw-bold pd-l-40">{{ $l('CommonTermsConditions') }}</div>
      <div class="flex-jc-bt item-close">
        <div v-title class="flex-50 pop-title">{{ $l('FullTerm') }}</div>
        <div class="flex-45">
          <div v-if="cargoInfo.charteringTerms?.full?.subject">{{ cargoInfo.charteringTerms?.full?.subject }}</div>
          <SpSection :content="cargoInfo.charteringTerms?.full?.content" base-height="65" />
          <!--          <div v-show="!cargoInfo.showInnerFullTermScroll" class="bfc mg-b-20 mg-t-20 text-center"> -->
          <!--            <SpIcon class="pointer" type="doubleSelect" @click="cargoInfo.showInnerFullTermScroll=true" /> -->
          <!--          </div> -->
          <!--          <SpScroll v-show="cargoInfo.showInnerFullTermScroll" width="300" height="200">{{  }}</SpScroll> -->
        </div>
      </div>
      <div class="flex-jc-bt item-close">
        <div v-title class="flex-50 pop-title">{{ $l('CargoDescriptioninCharteringOrder') }}</div>
        <div class="flex-45">
          <div v-show="!showInnerScroll" class="bfc mg-b-20 mg-t-20 text-center">
            <!--            <SpIcon class="pointer" type="doubleSelect" @click="showInnerScroll=true" /> -->
          </div>
          <SpScroll v-show="showInnerScroll" width="300" height="200">
            {{
              $l('CargoDescriptioninCharteringOrder')
            }}
          </SpScroll>
        </div>
      </div>
      <div class="flex-jc-bt item-close">
        <div v-title class="flex-50 pop-title">{{ $l('CargoDescriptionRequirementsforChartering') }}</div>
        <div class="flex-45">
          <div v-show="!showInnerScroll" class="bfc mg-b-20 mg-t-20 text-center">
            <!--            <SpIcon class="pointer" type="doubleSelect" @click="showInnerScroll=true" /> -->
          </div>
          <SpScroll v-show="showInnerScroll" width="300" height="200">
            {{
              $l('CargoDescriptionRequirementsforChartering')
            }}
          </SpScroll>
        </div>
      </div>
      <div class="flex-jc-bt item">
        <div v-title class="flex-50 pop-title">{{ $l('ProformaCP') }}</div>
        <div class="flex-45 pop-content">
          <ImgListPreview v-if="proformaPics.length > 0" :list="proformaPics" />
          <!--          <img v-for="url in cargoInfo.charteringTerms?.proforma?.pics" :src="url" width="68" height="38" class="mg-r-20 of-contain pointer" @click="showPicFull(url)"> -->
          <!--          <span class="sp-color-1">{{ $l('CPdocx') }}</span> -->
        </div>
      </div>
      <template v-if="showRightClaim">
        <SpDivider class="horizen-divider" direction="horizen" :opacity="0.4" />
        <p v-triangle class="fw-bold pd-l-40">{{ $l('Right Claim') }}</p>
        <div class="item pd-l-40">
          <div v-if="cargoInfo.ownershipStatus === 1" style="padding-left: 19px">{{ $l('OwnedCargo') }}</div>
          <div v-if="cargoInfo.ownershipStatus === 2" style="padding-left: 19px">{{ $l('OPCargo') }}</div>
          <div v-if="cargoInfo.ownership?.details && cargoInfo.ownership?.details?.length >0">
            <div v-for="de in cargoInfo.ownership.details" class="flex-jc-start">
              <span class="flex-50 sp-color-7 text-right">{{ de.ownership.name }}:</span>
              <div class="flex-45 pd-l-20" style="margin: 0">
                <div>
                  {{ Object.values(de.ownershipCorpIds).join(' , ') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!--      <div v-else class="item"> -->
      <!--        &lt;!&ndash;        <div>{{ $l('OPCargo') }}</div> &ndash;&gt; -->
      <!--        <div class="flex-jc-start"> -->
      <!--          <span class="flex-50 sp-color-7 text-right">{{ $l('OP Cargo') }}:</span> -->
      <!--          <p class="flex-45 pd-l-20" style="margin: 0"> {{ cargoInfo.ownership?.applicantCorpName }} </p> -->
      <!--        </div> -->
      <!--      </div> -->
      <!--    </div> -->
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import SpIcon from '@/components/common/SpIcon'
import SpScroll from '@/components/common/SpScroll'
import SpDivider from '@/components/common/SpDivider'
import { getCargoDetailApi, getCargoOwnershipTypeApi } from '@/request/APIs/co'
import { formatFiles } from '@/utils/convert'
import SpSection from '@/components/common/SpSection'
import { ref, watch } from 'vue'
import { computed } from '@vue/runtime-core'
import ImgListPreview from '../../../common/ImgListPreview'

export default {
  name: 'CargoCollectionMore',

  nameSpace: 'cargoOwner.cargo.CargoCollection',

  components: {
    ImgListPreview,
    SpSection,
    SpIcon,
    SpScroll,
    SpDivider
  },

  props: {
    data: {
      type: Object,
      default: () => ({})
    },

    cargoId: {
      type: [Number, String],
      default: null
    },

    showRightClaim: {
      type: Boolean,
      default: true
    }
  },

  setup (props, cxt) {
    const picSrc = ref('')
    const showPic = ref(false)
    const cargoInfo = ref({
      charteringTerms: {
        full: {
          content: null
        },
        proforma: {
          content: null
        }
      }
    })
    const cargoOwnershipType = ref([])
    const getCargoOwnershipType = () => {
      getCargoOwnershipTypeApi().then(res => {
        cargoOwnershipType.value = res.data
      })
    }
    getCargoOwnershipType()

    const getCargoDetail = (id) => {
      // cargoInfo.value = {}
      getCargoDetailApi(id).then(res => {
        if (res.code === 1) {
          const data = res.data

          cargoInfo.value = data
        }
      })
    }
    watch(() => props.cargoId, (val) => {
      if (val) {
        getCargoDetail(val)
      }
    })

    const cargoPics = computed(() => {
      return formatFiles(cargoInfo.value, 'cargoPics')
    })
    const proformaPics = computed(() => {
      return cargoInfo.value.charteringTerms?.proforma ? formatFiles(cargoInfo.value.charteringTerms?.proforma, 'content') : []
    })
    const fullContent = computed(() => {
      return cargoInfo.value.charteringTerms?.full?.content || ''
    })
    return {
      picSrc,
      showPic,
      cargoInfo,
      cargoOwnershipType,
      getCargoOwnershipType,
      getCargoDetail,
      cargoPics,
      proformaPics,
      fullContent
    }
  }
}
</script>

<style scoped lang="less">
.dialog-more {
  padding: @gap*3 @gap @gap*3 @gap;
  @fontWeight: 500;

  .item, .item-close {
    .title {
      font-weight: @fontWeight;
      opacity: 0.8;
    }

    .pop-title {
      .title();
      text-align: right;
    }

    .pop-content {
      font-weight: @fontWeight+50;
      text-align: left;
      white-space: pre-wrap;
      word-break: break-all;
    }
  }

  .item {
    margin: @gap/2 0 @gap/2 0;
  }

  .item-close {
    margin: @gap/4 0 @gap/4 0;
  }

  .divider {
    margin: @gap*2 0 @gap*2 0;
  }

  .border-label {
    margin-top: @gap/2;
    width: 70%;
    text-align: left;
    padding: @gap/2 0 @gap/2 0;
    text-indent: 1em;
  }

}
</style>
